<template>
  <div class="pass">
    <div class="top"></div>
    <div class="bottom"></div>
    <router-view class="router"></router-view>
  </div>
</template>

<script>
  export default{

  }
</script>

<style scoped>
  .pass{
    position: absolute;
    top:0;
    bottom:0;
    width: 100%;
  }
  .top{
    height: 50%;
    background: #00b38a;
  }
  .bottom{
    height: 50%;
    background: #f9f9f9;
  }
  @media screen and (max-width: 414px){
    .bottom{
      background: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pass/Pass.router.vue